export class StrainRegistryCode {
    public id: number;
    public name: string;
    public code: string;

    constructor(code: any) {
        this.id = code.id;
        this.name = code.name;
        this.code = code.code;
    }
}
